(function(){
  function iconSVG(kind){
    var icons = {
      instagram: '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="nmig" x1="0" x2="1" y1="1" y2="0"><stop offset="0%" stop-color="#feda75"/><stop offset="45%" stop-color="#fa7e1e"/><stop offset="70%" stop-color="#d62976"/><stop offset="100%" stop-color="#4f5bd5"/></linearGradient></defs><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" fill="url(#nmig)"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="#fff" stroke-width="1.9"/><circle cx="17.2" cy="6.9" r="1.2" fill="#fff"/></svg>',
      tiktok: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" fill="#111"/><path d="M14.8 6.4c.8 1.2 1.8 1.9 3.1 2.1v2.2a5.8 5.8 0 0 1-3.1-1v4.4c0 2.4-1.9 4.4-4.5 4.4-2 0-3.4-1.1-4.1-2.7.6.5 1.4.8 2.3.8 1.9 0 3.4-1.4 3.4-3.2V5.6h2.9v.8Z" fill="#25F4EE"/><path d="M14.4 6c.8 1.2 1.8 1.9 3.1 2.1v2.2a5.8 5.8 0 0 1-3.1-1v4.4c0 2.4-1.9 4.4-4.5 4.4-1 0-1.9-.3-2.6-.8.6.2 1 .3 1.6.3 1.9 0 3.4-1.4 3.4-3.2V5.2h2.1V6Z" fill="#FE2C55"/></svg>',
      whatsapp: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" fill="#25D366"/><path d="M12 6.2a5.8 5.8 0 0 0-4.9 8.9l-.6 2.7 2.8-.6a5.8 5.8 0 1 0 2.7-11Z" fill="#fff"/><path d="M15.2 13.7c-.2-.1-1.1-.5-1.3-.6-.2-.1-.3-.1-.4.1l-.4.6c-.1.1-.2.2-.4.1-.9-.4-1.6-1-2.1-1.8-.1-.2 0-.3.1-.4l.3-.3c.1-.1.1-.2.2-.3 0-.1 0-.2 0-.3l-.6-1.4c-.1-.2-.2-.2-.4-.2h-.3c-.1 0-.3 0-.4.2-.2.2-.7.7-.7 1.7s.8 2 1 2.2c.1.1 1.5 2.3 3.7 3.1 2.1.8 2.1.5 2.5.5.4 0 1.2-.5 1.4-1 .2-.5.2-1 .1-1.1 0-.1-.2-.2-.4-.3Z" fill="#25D366"/></svg>',
      facebook: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.2" y="2.2" width="19.6" height="19.6" rx="6" fill="#1877F2"/><path d="M13.5 20v-6.2h2.1l.3-2.4h-2.4V9.9c0-.7.2-1.2 1.2-1.2H16V6.5c-.2 0-.9-.1-1.7-.1-1.7 0-2.8 1-2.8 3v1.9H9.6v2.4h1.9V20h2Z" fill="#fff"/></svg>'
    };
    return icons[kind] || '';
  }

  function detectKind(url){
    var u = (url || '').toLowerCase();
    if (u.indexOf('instagram') > -1) return 'instagram';
    if (u.indexOf('tiktok') > -1) return 'tiktok';
    if (u.indexOf('whatsapp') > -1 || u.indexOf('wa.me') > -1 || u.indexOf('api.whatsapp.com') > -1) return 'whatsapp';
    if (u.indexOf('facebook') > -1 || u.indexOf('fb.com') > -1) return 'facebook';
    return '';
  }

  function enhanceContactSidebar(){
    var modules = Array.prototype.slice.call(document.querySelectorAll('.sidebar-module'));
    modules.forEach(function(module){
      var title = module.querySelector('.section-header__title');
      if (!title) return;
      if (!/contacto/i.test(title.textContent || '')) return;

      module.classList.add('nm-contact-sidebar');
      var content = module.querySelector(':scope > div:last-child');
      if (!content) return;

      var paragraphs = Array.prototype.slice.call(content.querySelectorAll('p'));
      paragraphs.forEach(function(p){
        var text = (p.textContent || '').trim();
        if (!text) return;
        if (/contáctanos|contactanos|servicio al cliente|atenderá|atendera/i.test(text)) p.classList.add('nm-contact-copy');
        if (/@/.test(text)) p.classList.add('nm-contact-line');
        if (/whatsapp/i.test(text) || /\b55\d{8}\b/.test(text.replace(/\s+/g,''))) p.classList.add('nm-contact-line');
      });

      var links = Array.prototype.slice.call(content.querySelectorAll('a'));
      var socials = [];
      links.forEach(function(a){
        var kind = detectKind(a.getAttribute('href') || '');
        if (!kind) return;
        if (socials.some(function(s){ return s.kind === kind; })) return;
        socials.push({ kind: kind, href: a.href });
        var holder = a.closest('p') || a;
        holder.classList.add('nm-contact-social-source');
      });

      if (socials.length){
        var row = content.querySelector('.nm-contact-socials');
        if (!row){
          row = document.createElement('div');
          row.className = 'nm-contact-socials';
          content.appendChild(row);
        }
        row.innerHTML = socials.map(function(item){
          return '<a href="' + item.href + '" target="_blank" rel="noopener noreferrer" aria-label="' + item.kind + '">' + iconSVG(item.kind) + '</a>';
        }).join('');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContactSidebar);
  } else {
    enhanceContactSidebar();
  }

  setTimeout(enhanceContactSidebar, 1200);
})();
